'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadAvailableDesignTemplateData = loadAvailableDesignTemplateData;
exports.loadAvailableContentTemplateData = loadAvailableContentTemplateData;
exports.loadAdditionalCompanyData = loadAdditionalCompanyData;
exports.makePayment = makePayment;
exports.isDesignLoaded = isDesignLoaded;
exports.isContentLoaded = isContentLoaded;
exports.isAdditionalCompanyDataLoaded = isAdditionalCompanyDataLoaded;
exports.showColorPicker = showColorPicker;
exports.showSpacingPicker = showSpacingPicker;
exports.showCharts = showCharts;
exports.showFontPicker = showFontPicker;
exports.getAPI = getAPI;
exports.getDivContentId = getDivContentId;
exports.setAPI = setAPI;
exports.checkHiration = checkHiration;
exports.showZipRecruiterModal = showZipRecruiterModal;
exports.showPaymentModal = showPaymentModal;

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_COMPANY_TEMPLATES = 'company/LOAD_TEMPLATE';
var LOAD_COMPANY_TEMPLATES_SUCCESS = 'company/LOAD_SUCCESS';
var LOAD_COMPANY_TEMPLATES_FAIL = 'company/LOAD_FAIL';
var LOAD_COMPANY_CONTENT = 'company/LOAD_COMPANY_CONTENT';
var LOAD_COMPANY_CONTENT_SUCCESS = 'company/LOAD_COMPANY_CONTENT_SUCCESS';
var LOAD_COMPANY_CONTENT_FAIL = 'company/LOAD_COMPANY_CONTENT_FAIL';
var LOAD_ADDITIONAL_COMPANY_DATA = 'company/LOAD_ADDITIONAL_COMPANY_DATA';
var LOAD_ADDITIONAL_COMPANY_DATA_SUCCESS = 'company/LOAD_ADDITIONAL_COMPANY_DATA_SUCCESS';
var LOAD_ADDITIONAL_COMPANY_DATA_FAIL = 'company/LOAD_ADDITIONAL_COMPANY_DATA_FAIL';
var MAKE_PAYMENT = 'company/MAKE_PAYMENT';
var MAKE_PAYMENT_SUCCESS = 'company/MAKE_PAYMENT_SUCCESS';
var MAKE_PAYMENT_FAIL = 'company/MAKE_PAYMENT_FAIL';
var SET_API = 'company/SET_API';
var SET_GA = 'company/SET_GA';
var SET_TOKEN = 'company/SET_TOKEN';
var SET_COMPANY = 'company/SET_COMPANY';
var SHOW_DESIGN_LABEL = 'company/SHOW_DESIGN_LABEL';
var SHOW_CONTENT_LABEL = 'company/SHOW_CONTENT_LABEL';
var SHOW_COLOR_PICKER = 'company/SHOW_COLOR_PICKER';
var SHOW_FONT_PICKER = 'company/SHOW_FONT_PICKER';
var SHOW_SPACING_PICKER = 'company/SHOW_SPACING_PICKER';
var SHOW_CHARTS = 'company/SHOW_CHARTS';
var SHOW_ZIP_RECRUITER = 'company/SHOW_ZIP_RECRUITER';
var SHOW_ZIP_RECRUITER_MODAL = 'company/SHOW_ZIP_RECRUITER_MODAL';
var SHOW_PAYMENT_MODAL = 'company/SHOW_PAYMENT_MODAL';
var DIV_CONTENT_ID = 'company/DIV_CONTENT_ID';
var BASE_URL = 'company/BASE_URL';
var REDIRECT_URL = 'company/REDIRECT_URL';
var USE_SSO_LOGIN = 'company/USE_SSO_LOGIN';
var SSO_ENDPOINT = 'company/SSO_ENDPOINT';
var TARGET_URL = 'company/TARGET_URL';
var BRAND_COLOR = 'company/BRAND_COLOR';
var BRAND_LOGO = 'company/BRAND_LOGO';
var SHOW_FREE_REVIEW = 'company/SHOW_FREE_REVIEW';
var SHOW_ACCOUNT_DROPDOWN = 'company/SHOW_ACCOUNT_DROPDOWN';
var SHOW_RESUME_REWRITE = 'company/SHOW_RESUME_REWRITE';
var SHOW_GET_PREMIUM = 'company/SHOW_GET_PREMIUM';
var SHOW_GET_PREMIUM_IN_APP = 'company/SHOW_GET_PREMIUM_IN_APP';
var SHOW_TIMELINE = 'company/SHOW_TIMELINE';
var SHOW_ADD_NEW_SECTION = 'company/SHOW_ADD_NEW_SECTION';
var BASIC_BUILDER = 'company/BASIC_BUILDER';
var SHOW_RESUME_EDIT_LABEL = 'company/SHOW_RESUME_EDIT_LABEL';
var SHOW_TEXT_ANALYSIS_MENU = 'company/SHOW_TEXT_ANALYSIS_MENU';
var SHOW_MY_RESUMES = 'company/SHOW_MY_RESUMES';
var IS_HIRATION = 'company/IS_HIRATION';
var SHOW_IMAGE_UPLOAD = 'company/SHOW_IMAGE_UPLOAD';
var SHOW_SAVE_BUTTON = 'company/SHOW_SAVE_BUTTON';
var SHOW_COMMENT_BUTTON = 'company/SHOW_COMMENT_BUTTON';
var RESUME_REVIEW = 'company/RESUME_REVIEW';

// ReactGA.initialize('UA-98787165-1', {debug: true});

var initialState = {
  api_key: 111,
  token: false,
  ga_code: 'UA-98787165-1',
  react_ga: _reactGa2.default,
  design_loaded: false,
  content_loaded: false,
  additional_company_data_loaded: false,
  show_payment_modal: false,
  loading: false,
  design_templates: false,
  content_templates: false,
  show_resume_edit_label: false,
  max_resumes: -1,
  all_templates_free: false,
  name: false,
  show_design_label: false,
  show_content_label: false,
  show_color_picker: false,
  show_font_picker: false,
  show_charts: false,
  div_content_id: 'content',
  type_of_document: 'Resume',
  show_spacing_picker: false,
  show_zip_recruiter: false,
  show_zip_recruiter_modal: false,
  show_timeline: false,
  show_image_upload: false,
  show_add_new_section: false,
  base_url: '/app',
  target_url: 'https://resume.hiration.com',
  redirect_url: 'https://learning.edureka.co/mycourses',
  use_sso_login: true,
  sso_endpoint: 'https://api-auth.edureka.co/sso/verify',
  brand_color: 'rgb(58,86,128)',
  brand_logo: 'https://s3-us-west-2.amazonaws.com/hiration/edureka/edureka.png',
  show_get_premium: false,
  show_get_premium_in_app: false,
  show_free_review: false,
  show_resume_rewrite: false,
  show_account_dropdown: false,
  show_resume_review_on_download: false,
  basic_builder: false,
  making_payment: false,
  payment_success: false,
  selected_plan: false,
  payment_amount: false,
  show_text_analysis_menu: false,
  is_hiration: false,
  show_my_resumes: false,
  show_save_button: false,
  show_comment_button: false,
  resume_review: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_GA:
      if (action.key) {
        _reactGa2.default.initialize(action.key, { debug: false });
      } else {
        _reactGa2.default.initialize('UA-98787165-1', { debug: false });
      }
      return (0, _extends3.default)({}, state, {
        ReactGA: _reactGa2.default
      });
      break;
    case BASIC_BUILDER:
      if (action.key) {
        return (0, _extends3.default)({}, state, {
          basic_builder: action.key
        });
      }
      return (0, _extends3.default)({}, state);
      break;
    case BASE_URL:
      if (action.key) {
        return (0, _extends3.default)({}, state, {
          base_url: action.key
        });
      }
      return (0, _extends3.default)({}, state);
      break;
    case BRAND_LOGO:
      // if(action.key)
      return (0, _extends3.default)({}, state, {
        brand_logo: action.key
      });
    case BRAND_COLOR:
      if (action.key) return (0, _extends3.default)({}, state, {
        brand_color: action.key
      });
      return (0, _extends3.default)({}, state);
      break;
    case SHOW_FREE_REVIEW:
      if (action.key) return (0, _extends3.default)({}, state, {
        show_free_review: action.key
      });
      return (0, _extends3.default)({}, state);
    case SHOW_ACCOUNT_DROPDOWN:
      return (0, _extends3.default)({}, state, {
        show_account_dropdown: action.key
      });
    case SHOW_RESUME_REWRITE:
      return (0, _extends3.default)({}, state, {
        show_resume_rewrite: action.key
      });
    case SHOW_GET_PREMIUM:
      return (0, _extends3.default)({}, state, {
        show_get_premium: action.key
      });
    case SHOW_GET_PREMIUM_IN_APP:
      return (0, _extends3.default)({}, state, {
        show_get_premium_in_app: action.key
      });
    case SHOW_ZIP_RECRUITER:
      return (0, _extends3.default)({}, state, {
        show_zip_recruiter: action.key
      });
    case SHOW_IMAGE_UPLOAD:
      return (0, _extends3.default)({}, state, {
        show_image_upload: action.key
      });
    case TARGET_URL:
      return (0, _extends3.default)({}, state, {
        target_url: action.key
      });
    case USE_SSO_LOGIN:
      return (0, _extends3.default)({}, state, {
        use_sso_login: action.key
      });
    case SSO_ENDPOINT:
      return (0, _extends3.default)({}, state, {
        sso_endpoint: action.key
      });
    case REDIRECT_URL:
      return (0, _extends3.default)({}, state, {
        redirect_url: action.key
      });
    case SET_API:
      return (0, _extends3.default)({}, state, {
        api_key: action.key
      });
    case IS_HIRATION:
      return (0, _extends3.default)({}, state, {
        is_hiration: action.key
      });
    case SET_TOKEN:
      return (0, _extends3.default)({}, state, {
        token: action.key
      });
    case SET_COMPANY:
      return (0, _extends3.default)({}, state, {
        name: action.key
      });
    case SHOW_DESIGN_LABEL:
      return (0, _extends3.default)({}, state, {
        show_design_label: action.key
      });
    case SHOW_CONTENT_LABEL:
      return (0, _extends3.default)({}, state, {
        show_content_label: action.key
      });
    case SHOW_COLOR_PICKER:
      return (0, _extends3.default)({}, state, {
        show_color_picker: action.key
      });
    case SHOW_SPACING_PICKER:
      return (0, _extends3.default)({}, state, {
        show_spacing_picker: action.key
      });
    case SHOW_CHARTS:
      return (0, _extends3.default)({}, state, {
        show_charts: action.key
      });
    case SHOW_FONT_PICKER:
      return (0, _extends3.default)({}, state, {
        show_font_picker: action.key
      });
    case SHOW_TIMELINE:
      return (0, _extends3.default)({}, state, {
        show_timeline: action.key
      });
    case SHOW_ADD_NEW_SECTION:
      return (0, _extends3.default)({}, state, {
        show_add_new_section: action.key
      });
    case SHOW_RESUME_EDIT_LABEL:
      return (0, _extends3.default)({}, state, {
        show_resume_edit_label: action.key
      });
    case SHOW_ZIP_RECRUITER_MODAL:
      return (0, _extends3.default)({}, state, {
        show_zip_recruiter_modal: action.data
      });
    case SHOW_PAYMENT_MODAL:
      return (0, _extends3.default)({}, state, {
        show_payment_modal: action.show_modal,
        selected_plan: action.plan,
        payment_amount: action.payment_amount
      });
    case SHOW_TEXT_ANALYSIS_MENU:
      return (0, _extends3.default)({}, state, {
        show_text_analysis_menu: action.key
      });
    case LOAD_COMPANY_TEMPLATES:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_COMPANY_TEMPLATES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        design_templates: action.result.data,
        loading: false,
        design_loaded: true
      });
    case LOAD_COMPANY_TEMPLATES_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        design_loaded: false
      });
    case LOAD_COMPANY_CONTENT:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_COMPANY_CONTENT_SUCCESS:
      if (action.result.data) {
        return (0, _extends3.default)({}, state, {
          content_templates: action.result.data,
          loading: false,
          content_loaded: true
        });
      } else {
        return (0, _extends3.default)({}, state, {
          loading: false,
          content_loaded: false
        });
      }
    case LOAD_COMPANY_CONTENT_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        content_loaded: false
      });
    case LOAD_ADDITIONAL_COMPANY_DATA:
      return (0, _extends3.default)({}, state, {
        additional_company_data_loaded: false
      });
    case LOAD_ADDITIONAL_COMPANY_DATA_SUCCESS:
      return (0, _extends3.default)({}, state, {
        max_resumes: action.result.data.max_resumes,
        all_templates_free: action.result.data.all_templates_free,
        loading: false,
        additional_company_data_loaded: true
      });
    case LOAD_ADDITIONAL_COMPANY_DATA_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        additional_company_data_loaded: false
      });
    case DIV_CONTENT_ID:
      var type_of_doc = void 0;
      if (action.key == 'cover_letter') {
        type_of_doc = 'Cover Letter';
      } else if (action.key == 'personal_website') {
        type_of_doc = 'Personal Website';
      } else {
        type_of_doc = 'Resume';
      }
      return (0, _extends3.default)({}, state, {
        div_content_id: action.key,
        type_of_document: type_of_doc
      });
    case MAKE_PAYMENT:
      return (0, _extends3.default)({}, state, {
        making_payment: true
      });
    case MAKE_PAYMENT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        making_payment: false,
        payment_success: true
      });
    case MAKE_PAYMENT_FAIL:
      return (0, _extends3.default)({}, state, {
        making_payment: false,
        payment_success: false
      });
    case SHOW_MY_RESUMES:
      // console.log('show_my_resumes',action.key)
      return (0, _extends3.default)({}, state, {
        show_my_resumes: action.key
      });
    case SHOW_SAVE_BUTTON:
      return (0, _extends3.default)({}, state, {
        show_save_button: action.key
      });
    case SHOW_COMMENT_BUTTON:
      return (0, _extends3.default)({}, state, {
        show_comment_button: action.key
      });
    case RESUME_REVIEW:
      return (0, _extends3.default)({}, state, {
        resume_review: action.key
      });
    default:
      return state;
  }
}

function loadAvailableDesignTemplateData(api_key, div_content_id) {
  return {
    types: [LOAD_COMPANY_TEMPLATES, LOAD_COMPANY_TEMPLATES_SUCCESS, LOAD_COMPANY_TEMPLATES_FAIL],
    promise: function promise(client) {
      return client.get('/load-available-templates/?api_key=' + api_key + '&template_type=' + div_content_id);
    }
  };
}

function loadAvailableContentTemplateData(api_key, div_content_id) {
  return {
    types: [LOAD_COMPANY_CONTENT, LOAD_COMPANY_CONTENT_SUCCESS, LOAD_COMPANY_CONTENT_FAIL],
    promise: function promise(client) {
      return client.get('/load-available-contents/?api_key=' + api_key + '&template_type=' + div_content_id);
    }
  };
}

function loadAdditionalCompanyData(api_key) {
  return {
    types: [LOAD_ADDITIONAL_COMPANY_DATA, LOAD_ADDITIONAL_COMPANY_DATA_SUCCESS, LOAD_ADDITIONAL_COMPANY_DATA_FAIL],
    promise: function promise(client) {
      return client.get('/load-additional-company-data/?api_key=' + api_key);
    }
  };
}

function makePayment(data) {
  return {
    types: [MAKE_PAYMENT, MAKE_PAYMENT_SUCCESS, MAKE_PAYMENT_FAIL],
    promise: function promise(client) {
      return client.post('/make-payment/', { data: data });
    }
  };
}

function isDesignLoaded(globalState) {
  return globalState.company.design_loaded;
}

function isContentLoaded(globalState) {
  return globalState.company.content_loaded;
}

function isAdditionalCompanyDataLoaded(globalState) {
  return globalState.company.additional_company_data_loaded;
}

function showColorPicker(globalState) {
  return globalState.company.show_color_picker;
}

function showSpacingPicker(globalState) {
  return globalState.company.show_spacing_picker;
}

function showCharts(globalState) {
  return globalState.company.show_charts;
}

function showFontPicker(globalState) {
  return globalState.company.show_font_picker;
}

function getAPI(globalState) {
  return globalState.company.api_key;
}

function getDivContentId(globalState) {
  return globalState.company.div_content_id;
}

function setAPI(key) {
  return {
    type: SET_API,
    key: key
  };
}

function checkHiration(key) {
  return {
    type: IS_HIRATION,
    key: key
  };
}

function showZipRecruiterModal(data) {
  return {
    type: SHOW_ZIP_RECRUITER_MODAL,
    data: data
  };
}

function showPaymentModal(show_modal, plan, payment_amount) {
  return {
    type: SHOW_PAYMENT_MODAL,
    show_modal: show_modal,
    plan: plan,
    payment_amount: payment_amount
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/company.js
// module id = 210
// module chunks = 0